import React from "react";
import {Modal, Table, Tag, Tooltip} from "antd";
import {Link} from "react-router-dom";
import moment from "moment";
import {Shortener} from "components/_defaultComponents/Shortener/Shortener";
import {useCourierOnboarding} from "hooks/useCourierOnboarding";
import {useFetch} from "hooks/useFetch";
import stores from "store/stores";

// Sayıya tıklandığında açılan modalın başlığı, seçilen kategoriye göre değişir
const courierRequestCourierTypeTitles = {
    applicant: "Başvuran Kuryeler",
    missingDocument: "Eksik Belge Kuryeler",
    approved: "Onaylanan Kuryeler",
    rejected: "Olumsuz Kuryeler",
    called: "Aranan Kuryeler",
    reached: "Ulaşılan Kuryeler"
};

export const CourierRequestCouriersModal = ({visibility, courierRequestId, type, onCancel}) => {
    const {renderOnboardingStatus, renderOnboardingSubStatus} = useCourierOnboarding();

    // Detaylar artık liste yanıtında gelmiyor; sayıya tıklanınca ayrı bir istekle çekiliyor
    const [loading, courierListData] = useFetch({
        defaultDataValue: {data: []},
        fetchFn: stores.courierRequestStore.getCourierRequestCouriersByType.bind(null, {
            id: courierRequestId,
            type
        }),
        condition: visibility && !!courierRequestId && !!type,
        dependencies: [visibility, courierRequestId, type],
        waitForResponse: true
    });

    const columns = [
        {
            title: "Detay",
            dataIndex: ["_id"],
            key: "_id",
            width: "100px",
            ellipsis: {
                showTitle: false
            },
            render: text => (
                <Link to={`/couriers/${text}`} target="_blank">
                    Detay
                </Link>
            )
        },
        {
            title: "Başvuru Tarihi",
            dataIndex: ["applicationDate"],
            key: "applicationDate",
            width: 100,
            ellipsis: {
                showTitle: false
            },
            render: text => <Tooltip title={text}>{moment(text).format("DD.MM.YYYY")}</Tooltip>
        },
        {
            title: "İsmi",
            dataIndex: ["fullname"],
            key: "fullname",
            width: 150,
            render: text => <Shortener text={text} length={32} />
        },
        {
            title: "TCKN",
            dataIndex: ["tckn"],
            key: "tckn",
            width: 150,
            render: text => text
        },
        {
            title: "Telefonu",
            dataIndex: ["cellPhone"],
            key: "cellPhone",
            width: 150,
            render: text => text
        },
        {
            title: "İşe Alım Durumu",
            dataIndex: ["activationStep"],
            key: "activationStep",
            width: 150,
            render: (activationStep, courier) => (
                <>
                    <Tag data-testid="activationStep">
                        {renderOnboardingStatus({
                            activationStep
                        })}
                    </Tag>
                    <br />
                    <Tag data-testid="activationSubStep">
                        {renderOnboardingSubStatus({
                            activationSubStep: courier?.activationSubStep,
                            activationStep: courier?.activationStep
                        })}
                    </Tag>
                </>
            )
        }
    ];

    if (!visibility) {
        return null;
    }

    return (
        <Modal
            title={courierRequestCourierTypeTitles[type] || "Kuryeler"}
            visible={true}
            onCancel={onCancel}
            footer={null}
            width={900}
            destroyOnClose={true}
        >
            <Table
                scroll={{x: "min-content"}}
                columns={columns}
                dataSource={Array.isArray(courierListData?.data) ? courierListData.data : []}
                loading={loading}
                pagination={{pageSize: 10, hideOnSinglePage: true}}
                rowKey="_id"
                size="small"
            />
        </Modal>
    );
};
